"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  name: 'DetailFunctionTable',
  data: function data() {
    return {
      tableData: [],
      functionList: [],
      checkList: [],
      isShow: false,
      addTitle: '新增',
      addData: {
        downMonitorNum: '',
        downDataParser: '',
        isConvert: 'false',
        isSubjoin: 'false' },

      rules: {} };


  },
  filters: {
    additionalValueFilter: function additionalValueFilter(val) {
      if (val == null) {
        return '--';
      } else if (val == '') {
        return '--';
      } else {
        return val;
      }
    } },

  mounted: function mounted() {
    this.handleGetFunctionList();
  },
  methods: {
    handleGetData: function handleGetData(data) {
      this.tableData = data;
    },
    handleAdd: function handleAdd() {
      var self = this;
      if (self.functionList.length > 0) {
        self.isShow = true;
      } else {
        self.tableData.push({ 'functionItemName': '', 'modelValue': '', 'upValue': '', 'downValue': '' });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkList = val;
    },
    handleDoSelect: function handleDoSelect() {var _this = this;
      console.log(this.checkList);
      this.checkList.forEach(function (val) {
        var data = { 'functionItemName': val.itemName, 'modelValue': val.itemValue, 'upValue': '', 'downValue': '' };
        _this.tableData.push(data);
      });
      this.handleCloseDog();
    },
    handleDel: function handleDel(index) {
      this.tableData.splice(index, 1);
    },
    handleChangeSubjoin: function handleChangeSubjoin() {
      if (this.addData.isSubjoin === 'true') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    // 功能转换-选择列表
    handleGetFunctionList: function handleGetFunctionList(code) {
      var self = this;
      self.getData('/api/deviceModelFuncItem/functioncode/' + code, {}, function (res) {
        self.functionList = res;
        if (res.length > 0) {
          self.addTitle = '选择';
        } else {
          self.addTitle = '新增';
        }
      });
    },
    handleGetResult: function handleGetResult() {
      return this.tableData;
    },
    handleCloseDog: function handleCloseDog() {
      this.isShow = false;
    },
    handleChangeConvert: function handleChangeConvert() {
    } } };exports.default = _default;